import * as React from 'react';

var _path, _mask, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgStarHalfGolden(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.284 14.101a.954.954 0 01-.446-.11l-3.502-1.843-3.501 1.845a.956.956 0 01-1.334-.488.964.964 0 01-.057-.524l.673-3.916-2.828-2.77a.962.962 0 01.53-1.64l3.917-.57 1.74-3.55A.96.96 0 017.84.145a.96.96 0 01.354.39l1.75 3.558 3.916.571a.957.957 0 01.773.654.965.965 0 01-.242.985l-2.828 2.77.673 3.916a.963.963 0 01-.942 1.123l-.01-.01z",
    fill: "#C6CACD"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "StarHalfGolden_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.284 14.101a.954.954 0 01-.446-.11l-3.502-1.843-3.501 1.845a.956.956 0 01-1.334-.488.964.964 0 01-.057-.524l.673-3.916-2.828-2.77a.962.962 0 01.53-1.64l3.917-.57 1.74-3.55A.96.96 0 017.84.145a.96.96 0 01.354.39l1.75 3.558 3.916.571a.957.957 0 01.773.654.965.965 0 01-.242.985l-2.828 2.77.673 3.916a.963.963 0 01-.942 1.123l-.01-.01z",
    fill: "#C6CACD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#StarHalfGolden_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#StarHalfGolden_svg__paint0_linear)",
    d: "M-.568-.081H7.38v14.923H-.568z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "StarHalfGolden_svg__paint0_linear",
    x1: -0.019,
    y1: 1.247,
    x2: 15.18,
    y2: 10.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE259"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#FFE259"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA751"
  })))));
}

export { SvgStarHalfGolden as ReactComponent };
//# sourceMappingURL=StarHalfGolden.svg.js.map
